// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"576":"ea5e2fe4","767":"fe97bbaf"}[chunkId] + ".chunk.js";
};